import { CdkDragDrop } from '@angular/cdk/drag-drop'
import { AfterViewInit, Component, EventEmitter, Input, OnDestroy, Output, ViewChild } from '@angular/core'
import { IProject } from '@app/projects-module/core/data-types/project.interface'
import { Optional } from '@app/shared/data-types/optional.types'
import { TranslateService } from '@app/shared/services/translate'
import locales from './locales'
import { CurrentOrganization } from '@shared/services/current-organization'
import { IFavoriteProject } from '@app/projects-module/core/data-types/favorite-projects.interface'
import { IProjectFavoritePosition } from '@app/projects-module/state/favorite-projects/favorite-projects-store.facade'
import { ProjectMenuItems } from '@app/shared/components/project-menu'
import { NgScrollbar } from 'ngx-scrollbar'
import { IScrollbarEvent, ScrollbarService } from '@app/shared/components/scrollbar'
import { Subject, takeUntil } from 'rxjs'
import { BreakpointsService } from '@app/shared/services/breakpoints'
import { ScreenSizes } from '@app/shared/data-types/breakpoints.types'
import { IsActiveMatchOptions } from '@angular/router'

@Component({
  selector: 'projects-menu',
  templateUrl: './projects-menu.component.html',
  styleUrls: ['./projects-menu.component.scss'],
  standalone: false,
})
export class ProjectsMenuComponent implements AfterViewInit, OnDestroy {
  @Input() projects: Optional<IFavoriteProject[]> = []
  @Output() onUpdateFavoritePosition = new EventEmitter<{
    newOrder: IProjectFavoritePosition[]
    oldOrder: IProjectFavoritePosition[]
  }>()
  @ViewChild(NgScrollbar) scrollbarRef: NgScrollbar
  t = this.translate.create(locales)

  projectMenuItems = ProjectMenuItems
  private destroy$ = new Subject<void>()
  rlao: IsActiveMatchOptions = { paths: 'exact', queryParams: 'ignored', matrixParams: 'ignored', fragment: 'ignored' }

  constructor(
    private translate: TranslateService,
    public currentOrganization: CurrentOrganization,
    private scrollbarService: ScrollbarService,
    private breakpointsService: BreakpointsService
  ) {}

  isDragDisabled$ = this.breakpointsService.isMatch([ScreenSizes.PHONE, ScreenSizes.TABLET_SM, ScreenSizes.TABLET])

  ngAfterViewInit(): void {
    this.scrollbarService.add(this.scrollbarRef)
    this.scrollbarRef.scrolled.pipe(takeUntil(this.destroy$)).subscribe((v) => {
      const event: IScrollbarEvent = {
        isScrolling: true,
        el: this.scrollbarRef.nativeElement,
      }
      this.scrollbarService.scrolling(event)
    })
  }

  ngOnDestroy() {
    this.destroy$.next()
    this.destroy$.complete()
    this.scrollbarService.remove(this.scrollbarRef)
  }

  drop(event: CdkDragDrop<IProject[]>): void {
    if (event.previousIndex == event.currentIndex) {
      return
    }
    const projects = this.projects!.slice()
    const oldOrder = projects.map((p, i) => {
      return {
        id: p.id,
        projectId: p.project_id,
        position: i,
      }
    })
    projects.splice(event.currentIndex, 0, projects.splice(event.previousIndex, 1)[0])
    const newOrder = projects.map((p, i) => {
      return {
        id: p.id,
        projectId: p.project_id,
        position: i,
      }
    })
    this.onUpdateFavoritePosition.emit({ oldOrder, newOrder })
  }
}
